import { SecondFactorTitleEnum } from '../bdb-second-factor-selector/models/second-factor-title-enum';
import { SecondFactorIconEnum } from '../bdb-second-factor-selector/models/second-factor-icon-enum';

export default class WebcomponentParam {

    public icon: string;
    public title: string;
    public desc?: string;
    public value: string;

    constructor(value: string,
                desc: SecondFactorTitleEnum | string,
                title?: string,
                icon?: SecondFactorIconEnum
                ) {
        this.icon = icon;
        this.title = title;
        this.desc = desc;
        this.value = value;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/webcomponent-param.ts